// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"b92d3464","630":"f7412fed"}[chunkId] + ".chunk.css";
};